/* MagFit v7: zaakceptowany cennik. Publikacja wymaga testu zgodności wariantów Shopify. */
(function () {
  'use strict';
  const config = {
    demoMode: false,
    minimumDays: 5,
    cutoffHour: 23,
    cutoffMinute: 59,
    leadCalendarDays: 2,
    timeZone: 'Europe/Warsaw',
    products: [
      { id: 'balance', name: 'Balance', emoji: '', description: 'Zbilansowana propozycja na co dzień.', priceFrom: 56.25, variantId: null },
      { id: 'sport', name: 'Sport', emoji: '', description: 'Propozycja dla osób aktywnych fizycznie.', priceFrom: 56.25, variantId: null },
      { id: 'lowcarb', name: 'Low Carb', emoji: '', description: 'Model jedzenia z ograniczonym udziałem węglowodanów.', priceFrom: 56.25, variantId: null },
            { id: 'vege', name: 'Vege', emoji: '', description: 'Dieta bez mięsa i ryb; może zawierać jaja i nabiał. Nie oznacza diety wegańskiej.', priceFrom: 56.25, variantId: null },
      { id: 'sibo', name: 'SIBO / Low FODMAP', emoji: '', description: 'Wariant do omówienia ze specjalistą. Dopasowanie do Low FODMAP i indywidualnych zaleceń wymaga potwierdzenia.', priceFrom: 56.25, variantId: null }
    ],
    images: {
      balance: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_19.png',
      sport: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_17.png',
      lowcarb: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_13.png',
      vege: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_23.png',
      sibo: 'https://cdn.shopify.com/s/files/1/1016/5125/1543/files/ChatGPT_Image_16_maj_2026_o_15_13_29.png'
    },
    // Liczba posiłków nie zmienia ceny; cena zależy od diety i kaloryczności.
    kcalOptions: [1300,1500,1800,2000,2500,3000,3500,4000,4500].map(kcal => ({kcal})),
    prices: {
      balance: [75,85,90,95,110,125,135,145,155],
      sport: [80,90,95,100,115,130,145,155,165],
      lowcarb: [80,90,95,100,115,130,145,155,165],
      vege: [85,99,105,110,120,140,150,160,170],
      sibo: [85,99,105,110,120,140,150,160,170]
    },
    mealOptions: [{count:3,factor:1},{count:4,factor:1},{count:5,factor:1}],
    discountCodes: {},
    delivery: {
      provisional: true,
      cost: 0,
      window: 'wieczorem poprzedzającym dzień diety',
      postcodeVerification: 'CITY_POSTCODE',
      surchargeVariantId: 55452926968151,
      surchargeHandle: "dostawa-do-dobrzan-doplata-za-1-dzien",
      locations: [
  {
    "name": "Stargard",
    "postcodes": [
      "73-100",
      "73-102",
      "73-103",
      "73-104",
      "73-106",
      "73-110",
      "73-114",
      "73-117"
    ],
    "surchargePerDay": 0,
    "simc": "0979596"
  },
  {
    "name": "Barnim",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784846"
  },
  {
    "name": "Barnim C",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Barnim"
  },
  {
    "name": "Barzkowice",
    "postcodes": [
      "73-134"
    ],
    "surchargePerDay": 0,
    "simc": "0783284"
  },
  {
    "name": "Białuń",
    "postcodes": [
      "73-112",
      "73-113"
    ],
    "surchargePerDay": 0,
    "simc": "0782907"
  },
  {
    "name": "Bielkowo",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777556"
  },
  {
    "name": "Brudzewice",
    "postcodes": [
      "73-131",
      "73-134"
    ],
    "surchargePerDay": 0,
    "simc": "0783976"
  },
  {
    "name": "Brudzewice Kolonia",
    "postcodes": [
      "73-131",
      "73-134"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Brudzewice"
  },
  {
    "name": "Bębnikąt",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0
  },
  {
    "name": "Cisewo",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777562"
  },
  {
    "name": "Czarnkowo",
    "postcodes": [
      "73-121"
    ],
    "surchargePerDay": 0,
    "simc": "0778739"
  },
  {
    "name": "Dalewo",
    "postcodes": [
      "73-121"
    ],
    "surchargePerDay": 0,
    "simc": "0778745"
  },
  {
    "name": "Dobrzany",
    "postcodes": [
      "73-130"
    ],
    "surchargePerDay": 25,
    "simc": "0978875"
  },
  {
    "name": "Domanowo",
    "postcodes": [
      "73-131"
    ],
    "surchargePerDay": 0
  },
  {
    "name": "Dębica",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784852"
  },
  {
    "name": "Gogolewo",
    "postcodes": [
      "73-121"
    ],
    "surchargePerDay": 0,
    "simc": "0778768"
  },
  {
    "name": "Gogolewo Kolonia",
    "postcodes": [
      "73-121"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Gogolewo"
  },
  {
    "name": "Golczewo",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783315"
  },
  {
    "name": "Golina",
    "postcodes": [
      "73-134"
    ],
    "surchargePerDay": 0,
    "simc": "0783321"
  },
  {
    "name": "Golinka",
    "postcodes": [
      "73-134"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Barzkowice"
  },
  {
    "name": "Grabowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783338"
  },
  {
    "name": "Grzędzice",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783373"
  },
  {
    "name": "Grzędziczki",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Lipnik"
  },
  {
    "name": "Jęczydół",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777579"
  },
  {
    "name": "Kałęga",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777622"
  },
  {
    "name": "Kicko",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0782942"
  },
  {
    "name": "Kicko Letnisko",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Kicko"
  },
  {
    "name": "Kiczarowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783404"
  },
  {
    "name": "Klępino",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783410"
  },
  {
    "name": "Kobylanka",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777585"
  },
  {
    "name": "Kolin",
    "postcodes": [
      "73-115",
      "73-116"
    ],
    "surchargePerDay": 0,
    "simc": "0774546"
  },
  {
    "name": "Kolin Kolonia",
    "postcodes": [
      "73-115",
      "73-116"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Kolin"
  },
  {
    "name": "Kolonia Dolna-Grabowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Grabowo"
  },
  {
    "name": "Kolonia Grzędzice",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Grzędzice"
  },
  {
    "name": "Kolonia Kiczarowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Kiczarowo"
  },
  {
    "name": "Kolonia Nieznań",
    "postcodes": [
      "74-106"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Nieznań"
  },
  {
    "name": "Kolonia Tychowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Tychowo"
  },
  {
    "name": "Koszewko",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783427"
  },
  {
    "name": "Koszewo",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783433"
  },
  {
    "name": "Krzywnica",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0782959"
  },
  {
    "name": "Krąpiel",
    "postcodes": [
      "73-131"
    ],
    "surchargePerDay": 0,
    "simc": "0783440"
  },
  {
    "name": "Krępcewo",
    "postcodes": [
      "73-115"
    ],
    "surchargePerDay": 0,
    "simc": "0774552"
  },
  {
    "name": "Kunowo",
    "postcodes": [
      "73-102",
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0777591"
  },
  {
    "name": "Kurcewo",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783456"
  },
  {
    "name": "Kępinka",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "simc": "0783580"
  },
  {
    "name": "Kępy",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0778774"
  },
  {
    "name": "Kłęby",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784875"
  },
  {
    "name": "Lipnik",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783462"
  },
  {
    "name": "Lubowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783479"
  },
  {
    "name": "Luboń",
    "postcodes": [
      "73-134"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Barzkowice"
  },
  {
    "name": "Marianowo",
    "postcodes": [
      "73-121"
    ],
    "surchargePerDay": 0
  },
  {
    "name": "Małkocin",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783485"
  },
  {
    "name": "Maszewo",
    "postcodes": [
      "72-130"
    ],
    "surchargePerDay": 0
  },
  {
    "name": "Miedwiecko",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777711"
  },
  {
    "name": "Mokrzyca",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Żarowo"
  },
  {
    "name": "Morzyczyn",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777600"
  },
  {
    "name": "Moskorze",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0782994"
  },
  {
    "name": "Motaniec",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777616"
  },
  {
    "name": "Mężyki",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Grzędzice"
  },
  {
    "name": "Nieznań",
    "postcodes": [
      "74-106"
    ],
    "surchargePerDay": 0,
    "simc": "0783261"
  },
  {
    "name": "Nowa Dąbrowa",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0783019"
  },
  {
    "name": "Nowa Kobylanka",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777639"
  },
  {
    "name": "Nowe Kunowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "1067495"
  },
  {
    "name": "Nowy Przylep",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784881"
  },
  {
    "name": "Obryta",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784898"
  },
  {
    "name": "Omięcin",
    "postcodes": [
      "73-131"
    ],
    "surchargePerDay": 0
  },
  {
    "name": "Parlino",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0783025"
  },
  {
    "name": "Parlino Letnisko",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Parlino"
  },
  {
    "name": "Piaszcze",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Grabowo"
  },
  {
    "name": "Piaśnik",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Grabowo"
  },
  {
    "name": "Poczernin",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "simc": "0783522"
  },
  {
    "name": "Poczernin-Osiedle",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Poczernin"
  },
  {
    "name": "Podlesie",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Sowno"
  },
  {
    "name": "Przewłoki",
    "postcodes": [
      "73-115",
      "73-116"
    ],
    "surchargePerDay": 0,
    "simc": "0774612"
  },
  {
    "name": "Pstrowo",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Sowno"
  },
  {
    "name": "Pęzino",
    "postcodes": [
      "73-110",
      "73-131"
    ],
    "surchargePerDay": 0,
    "simc": "0783491"
  },
  {
    "name": "Radziszewo",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783730"
  },
  {
    "name": "Reptowo",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777680"
  },
  {
    "name": "Reńsko",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784906"
  },
  {
    "name": "Rogowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783539"
  },
  {
    "name": "Rokicie",
    "postcodes": [
      "73-112",
      "73-113"
    ],
    "surchargePerDay": 0,
    "simc": "0783031"
  },
  {
    "name": "Rzeplino",
    "postcodes": [
      "73-115",
      "73-116"
    ],
    "surchargePerDay": 0,
    "simc": "0774635"
  },
  {
    "name": "Siwkowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783692"
  },
  {
    "name": "Skalin",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783545"
  },
  {
    "name": "Smogolice",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "simc": "0783551"
  },
  {
    "name": "Sowno",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "simc": "0783568"
  },
  {
    "name": "Stara Dąbrowa",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0783054"
  },
  {
    "name": "Stara Dąbrowa Kolonia",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Stara Dąbrowa"
  },
  {
    "name": "Storkówko",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0783060"
  },
  {
    "name": "Strachocin",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783597"
  },
  {
    "name": "Strzebielewo",
    "postcodes": [
      "73-115",
      "73-116"
    ],
    "surchargePerDay": 0,
    "simc": "0774701"
  },
  {
    "name": "Strzyżno",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783611"
  },
  {
    "name": "Sułkowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783628"
  },
  {
    "name": "Swojcino",
    "postcodes": [
      "72-130"
    ],
    "surchargePerDay": 0,
    "simc": "0778892"
  },
  {
    "name": "Szemielino",
    "postcodes": [
      "73-115"
    ],
    "surchargePerDay": 0,
    "simc": "0774718"
  },
  {
    "name": "Tolcz",
    "postcodes": [
      "73-112",
      "73-113"
    ],
    "surchargePerDay": 0,
    "simc": "0783077"
  },
  {
    "name": "Trzebiatów",
    "postcodes": [
      "73-131"
    ],
    "surchargePerDay": 0,
    "simc": "0783657"
  },
  {
    "name": "Trzebień",
    "postcodes": [
      "73-115",
      "73-116"
    ],
    "surchargePerDay": 0,
    "simc": "0774724"
  },
  {
    "name": "Trąbki",
    "postcodes": [
      "73-121"
    ],
    "surchargePerDay": 0,
    "simc": "0778828"
  },
  {
    "name": "Tychowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783663"
  },
  {
    "name": "Ulikowo",
    "postcodes": [
      "73-131"
    ],
    "surchargePerDay": 0,
    "simc": "0783670"
  },
  {
    "name": "Warchlinko",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "simc": "0783700"
  },
  {
    "name": "Warchlino",
    "postcodes": [
      "73-109"
    ],
    "surchargePerDay": 0,
    "simc": "0783686"
  },
  {
    "name": "Warnice",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784935"
  },
  {
    "name": "Warnice B",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Warnice"
  },
  {
    "name": "Warnice C",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Warnice"
  },
  {
    "name": "Wielichówko",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777697"
  },
  {
    "name": "Wierzbno",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784941"
  },
  {
    "name": "Wierzchląd",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783717"
  },
  {
    "name": "Witkowo Drugie",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783723"
  },
  {
    "name": "Witkowo Pierwsze",
    "postcodes": [
      "73-102"
    ],
    "surchargePerDay": 0,
    "simc": "0783746"
  },
  {
    "name": "Wybudowanie-Żukowo",
    "postcodes": [
      "73-132"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Żukowo"
  },
  {
    "name": "Wójcin",
    "postcodes": [
      "74-201"
    ],
    "surchargePerDay": 0,
    "simc": "0784958"
  },
  {
    "name": "Zagość",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777728"
  },
  {
    "name": "Zaolzie",
    "postcodes": [
      "73-131",
      "73-134"
    ],
    "surchargePerDay": 0,
    "postalLocality": "Brudzewice"
  },
  {
    "name": "Załęcze",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0783002"
  },
  {
    "name": "Zieleniewo",
    "postcodes": [
      "73-108"
    ],
    "surchargePerDay": 0,
    "simc": "0777705"
  },
  {
    "name": "Łęczyca",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0782965"
  },
  {
    "name": "Łęczyna",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0782988"
  },
  {
    "name": "Łęczówka",
    "postcodes": [
      "73-112"
    ],
    "surchargePerDay": 0,
    "simc": "0782971"
  },
  {
    "name": "Święte",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783640"
  },
  {
    "name": "Żalęcino",
    "postcodes": [
      "73-115"
    ],
    "surchargePerDay": 0
  },
  {
    "name": "Żarowo",
    "postcodes": [
      "73-110"
    ],
    "surchargePerDay": 0,
    "simc": "0783752"
  },
  {
    "name": "Kołbacz",
    "postcodes": ["74-106"],
    "surchargePerDay": 0
  },
  {
    "name": "Żelewo",
    "postcodes": [
      "74-106"
    ],
    "surchargePerDay": 0,
    "simc": "0783255"
  },
  {
    "name": "Żukowo",
    "postcodes": [
      "73-132"
    ],
    "surchargePerDay": 0,
    "simc": "0784125"
  }
]
    }
  };
  config.delivery.locations.sort((a, b) => a.name === 'Stargard' ? -1 : b.name === 'Stargard' ? 1 : a.name.localeCompare(b.name, 'pl-PL'));
  config.products.forEach(p => { p.priceFrom = Math.min(...config.prices[p.id]); });
  window.MAGFIT_CONFIG = config;
  const money = value => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(value);

  function enhance(root) {
    root.querySelectorAll('[data-magfit-kcal-range]').forEach(el => {
      el.textContent = Math.min(...config.kcalOptions.map(o => o.kcal)) + '–' + Math.max(...config.kcalOptions.map(o => o.kcal));
    });
    root.querySelectorAll('[data-magfit-meal-range]').forEach(el => {
      el.textContent = Math.min(...config.mealOptions.map(o => o.count)) + '–' + Math.max(...config.mealOptions.map(o => o.count));
    });
    root.querySelectorAll('[data-magfit-price]').forEach(el => {
      if (!config.products.some(p => p.id === el.dataset.magfitPrice)) return;
      el.textContent = 'od ' + money(config.products.find(p => p.id === el.dataset.magfitPrice).priceFrom) + ' / dzień';
    });
    root.querySelectorAll('[data-magfit-price-note]').forEach(el => {
      el.textContent = window.location.pathname === '/' ? 'Liczba posiłków nie zmienia ceny.' : '1300 kcal · min. 5 dni pon.–pt. · liczba posiłków nie zmienia ceny.';
    });
    root.querySelectorAll('[data-magfit-delivery]').forEach(box => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const city = box.querySelector('[data-delivery-city]');
      const postcode = box.querySelector('[data-delivery-postcode]');
      const result = box.querySelector('[data-delivery-result]');
      const submit = box.querySelector('[data-delivery-submit]');
      const order = box.querySelector('[data-delivery-order]');
      const list = box.querySelector('[data-delivery-list]');
      config.delivery.locations.forEach(location => {
        const option = document.createElement('option');
        option.value = location.name;
        option.textContent = location.name + (location.surchargePerDay ? ' (+25 zł dostawa/dzień)' : '');
        city.append(option);
        const item = document.createElement('li');
        item.textContent = location.name;
        if (location.surchargePerDay) {
          const badge = document.createElement('strong');
          badge.className = 'magfit-service__surcharge';
          badge.textContent = '+25 zł dostawa/dzień';
          item.append(document.createTextNode(' '), badge);
        }
        list.append(item);
      });
      const other = document.createElement('option');
      other.value = '__outside';
      other.textContent = 'Mojej miejscowości nie ma na liście';
      city.append(other);
      function reset() { result.textContent = ''; order.hidden = true; }
      city.addEventListener('change', reset);
      postcode.setAttribute('inputmode','numeric');
      postcode.addEventListener('input', function(){
        const digits=postcode.value.replace(/\D/g,'').slice(0,5);
        postcode.value=digits.length>2?digits.slice(0,2)+'-'+digits.slice(2):digits;
        reset();
      });
      submit.addEventListener('click', function () {
        order.hidden = true;
        const location = config.delivery.locations.find(item => item.name === city.value);
        if (!location) {
          result.textContent = city.value === '__outside' ? 'Ta miejscowość nie jest na liście. Nie możesz wybrać tego adresu w konfiguratorze. Skontaktuj się z nami w sprawie rozszerzenia strefy.' : 'Wybierz miejscowość z listy.';
          city.focus();
          return;
        }
        if (!/^\d{2}-\d{3}$/.test(postcode.value.trim())) {
          result.textContent = 'Podaj kod pocztowy w formacie 99-999.';
          postcode.focus();
          return;
        }
        const supportedPostcodes = Array.isArray(location.postcodes) ? location.postcodes : [];
        if (!supportedPostcodes.length) {
          result.textContent = 'Nie możemy teraz potwierdzić kodu dla tej miejscowości. Skontaktuj się z nami.';
          return;
        }
        if (!supportedPostcodes.includes(postcode.value.trim())) {
          result.textContent = 'Kod pocztowy nie pasuje do wybranej miejscowości. Sprawdź miejscowość i kod pocztowy.';
          postcode.focus();
          return;
        }
        result.textContent = '✓ Dostarczamy do miejscowości ' + location.name + '. ' + (location.surchargePerDay ? 'Dostawa: +25 zł za każdy dzień diety. ' : 'Dostawa bezpłatna. ') + 'Twoją dietę przywieziemy wieczorem na kolejny dzień. Miejscowość i kod pocztowy są zgodne z bazą dostaw.';
        order.hidden = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(document));
  else enhance(document);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();

